import React, { lazy, Suspense, useState } from 'react';

import { Fallback } from './PdfConsentViewer.styled';

import { PdfConsentViewerError } from './PdfConsentViewerError';

const LazyPdfViewer = lazy(() => import('./LazyPdfViewer'));

export const PdfConsentViewer = ({ pdf }: { pdf: string }) => {
  const [loadError, setLoadError] = useState(false);
  const [isOlderBrowserError, setIsOlderBrowserError] = useState(false);

  const handlePdfViewerErrors = (isOlderBrowserError: boolean) => {
    setLoadError(true);
    setIsOlderBrowserError(isOlderBrowserError);
  };

  return (
    <>
      {!loadError ? (
        <Suspense fallback={<Fallback>Loading PDF viewer...</Fallback>}>
          <LazyPdfViewer pdf={pdf} onError={handlePdfViewerErrors} />
        </Suspense>
      ) : (
        <PdfConsentViewerError pdf={pdf} isOlderBrowserError={isOlderBrowserError} />
      )}
    </>
  );
};
